import { render, staticRenderFns } from "./b6.vue?vue&type=template&id=04e9cc2d&"
import script from "./b6.vue?vue&type=script&lang=js&"
export * from "./b6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports